import { useEffect, useState } from "react";
import Alert from "react-bootstrap/Alert";
import styled from "styled-components";

import { AlertMessage, AlertType } from "../../types/AlertMessage";
import { AlertContext } from "./AlertContext";

export interface AlertProps {
  children?: React.ReactNode;
}

const AlertWrapper = styled.div`
  position: absolute;
  bottom: 5px;
  right: 15px;
  z-index: 9999;
`;

const AlertProvider = ({ children }: AlertProps) => {
  const [alert, showAlert] = useState<AlertMessage | undefined>(undefined);

  useEffect(() => {
    if (!alert) return;
    setTimeout(() => {
      showAlert(undefined);
    }, alert.duration || 5000);
  }, [alert]);

  return (
    // the Provider gives access to the context to its children
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {alert && (
        <AlertWrapper>
          <Alert
            variant={
              alert.type === AlertType.Information
                ? "info"
                : alert.type === AlertType.Warning
                ? "warning"
                : "danger"
            }
          >
            {alert.message}
          </Alert>
        </AlertWrapper>
      )}
    </AlertContext.Provider>
  );
};

export default AlertProvider;
